import React, {PureComponent} from 'react'
import {connect} from 'react-redux'
import { formValueSelector,stopSubmit, isDirty } from 'redux-form'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import Paper from 'material-ui/Paper'

import _ from 'lodash'
import PersonIcon from 'material-ui/svg-icons/social/person';
import ReplyIcon from 'material-ui/svg-icons/content/reply';
import * as colors from 'material-ui/styles/colors';

import {Link} from 'react-router-dom'

import Calendar from '../components/Calendar'
import * as actions from '../actions'
import PageBase from '../components/PageBase'
import RoumuForm from './RoumuForm'
import SubHolidayForm from './forms/SubHolidayForm'

import gStyles from '../styles'

// import '../roumu.css'

import moment from 'moment'

import * as commons from '../commons';

import {
    isMobile
} from "react-device-detect";

import {typography} from 'material-ui/styles';

import {reset} from 'redux-form';

// import FullscreenDialog from 'material-ui-fullscreen-dialog'

const paidHolidayStyle = {
  fontWeight: "bold",
  marginLeft: "3", 
  marginRight: "3",
  "fontSize": 20
}

const validate = (values) => {

  const errors = {}
  const requiredFields = [
    'kenmeiCode',
    'startTime',
    'endTime',
    'costId'
  ]

    if (values.startTime) {
        values.startTime = values.startTime.replace(/[０-９：]/g, (s) => {
            return String.fromCharCode(s.charCodeAt(0) - 65248);
        });
    }

    if (values.endTime) {
        values.endTime = values.endTime.replace(/[０-９：]/g, (s) => {
            return String.fromCharCode(s.charCodeAt(0) - 65248);
        });
    }

  if (!values.kind || values.kind == 1) {

    requiredFields.forEach(field => {
      if (!values[field]) {
        errors[field] = '必須入力'
      }
    })

    if (values.startTime) {

      if (values.startTime.indexOf(':') == -1) {
        if (values.startTime.length == 3) {
          values.startTime = values.startTime.slice(0, 1) + ':' + values.startTime.slice(1, values.startTime.length)
        } else if (values.startTime.length == 4) {
          values.startTime = values.startTime.slice(0, 2) + ':' + values.startTime.slice(2, values.startTime.length)
        }
      }
      if (!commons.validateTime(values.startTime)){
        errors.startTime = '時刻が不正です。(例：10:00)'
      }
    }

    if (values.endTime) {
      if (values.endTime.indexOf(':') == -1) {
        if (values.endTime.length == 3) {
          values.endTime = values.endTime.slice(0, 1) + ':' + values.endTime.slice(1, values.endTime.length)
        } else if (values.endTime.length == 4) {
          values.endTime = values.endTime.slice(0, 2) + ':' + values.endTime.slice(2, values.endTime.length)
        }
      }
      if (!commons.validateTime(values.endTime)){

        const num = values.endTime.replace(":", "");
        if (commons.validateNumber(num) && 2400 < Number(num)) {
          errors.endTime = '24:00以降は登録できません。'
        } else {
          errors.endTime = '時刻が不正です。(例：10:00)'
        }
      } else {
        if (2400 < Number(values.endTime.replace(":", ""))) {
          errors.endTime = '24:00以降は登録できません。'
        }
      }
    }

    if (values.startTime && values.endTime) {
      if (
        commons.validateTime(values.startTime) &&
        commons.validateTime(values.endTime) &&
        (commons.toTimeNumber(values.startTime) > commons.toTimeNumber(values.endTime))) {
        errors.startTime = '時刻間隔が不正です。'
        errors.endTime = '時刻間隔が不正です。'
      }
    }

  }

  if (values.kind && values.kind >= 4) {

    const emptyFields = [
      'kenmeiCode',
      'startTime',
      'endTime',
      'costId',
      'workId',
    ]

    emptyFields.forEach(field => {
      if (values[field]) {
        errors[field] = '空にして下さい。'
      }
    })

  }

  if (!values.kind && !values.startTime) {
    errors.startTime = '必須入力'
  }

  return errors
}

class Roumu extends PureComponent {

  constructor(props) {
    super(props)
    this.state = {
      init: false,
    }
  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.auth) {

      if (!_.isEqual(this.props.auth.user, nextProps.auth.user)) {
        if (!this.state.init) {
          this.setState({init: true})
          this.initRoumu(nextProps.auth.user)
        }
      }

    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    this.initRoumu(this.props.auth.user)
  }

  initRoumu(user) {

    if (!user || !user.id) {
      return
    }

    const {
      match,
      history,
      init
    } = this.props


    let userId
    if (match.params.userId && (user.permission == 2 || user.permission == 3)) {
      userId = match.params.userId
    } else {
      userId = user.id
    }
 
    let start
    let end
    moment.locale(moment.locale(), { week: { dow: 1} })
    if (match.params.approvalDate && (user.permission == 2 || user.permission == 3)) {
      start = moment(match.params.approvalDate, 'YYYYMMDD').startOf('week').format('YYYYMMDDHHmmss')
      end = moment(match.params.approvalDate, 'YYYYMMDD').endOf('week').format('YYYYMMDDHHmmss')
    } else {
      start = moment().startOf('week').format('YYYYMMDDHHmmss')
      end = moment().endOf('week').format('YYYYMMDDHHmmss')
    }

    this.setState({init: true})
    init(userId, start, end)
  }

  render() {

    const {
      match,

      events, 

      editUserId,
      editUserName,
      editUser,

      kenmeiCodes,
      kenmeiCodeDataSource,
      works,
      yosanCosts,
      workHoliday,

      handeleKenmeiCodeChange,
      handleChangeWeek,
      removeEvents,
      approval,

      selectedKenmeiCode,
      selectedKind,
      selectedYosanId,

      alertOpen,
      handleAlertClose,

      formOpen,
      handleCalDayClick,
      handleCalEventClick,
      handleFormOK,
      handleFormNext,
      handleFormClose,

      handleApprovalClose,
      handleApprovalOK,

      handeleYosanCostClick,
      handeleWorkHolidayClick,

      //auth
      auth,
      //holiday 
      workHolidayId,
      workHolidayMode,
      subHolidayDate,
      workHolidayDate,
      workHolidayDates,
      handleWorkHolidayDrop,
      handleSubHolidayFormClose,
      subHolidayFormOpen,
      subHolidayFormEdit,

      dirty,
      handleLocalStorageSave,
      history,

      currentPaidHoliday,
      handleFormReset
    } = this.props

      let sameGroup = false
      if (editUser && auth && auth.user) {
        sameGroup = editUser.branchOfficeId == auth.user.branchOfficeId && editUser.departmentId == auth.user.departmentId
      }

      let myData = false
      if (editUser && auth && auth.user) {
          myData = editUser.id == auth.user.id
      }

    let formData = this.props.formData
    let currentKenmei = this.props.currentKenmei

    // if (formData && formData.date && Object.keys(formData).length == 1) {
    //   let localStorageForm = JSON.parse(window.localStorage.getItem('roumu'))
    //
    //   if (localStorageForm) {
    //     localStorageForm.date = formData.date
    //     formData = localStorageForm
    //   }
    //
    //   if (kenmeiCodes && formData.kenmeiCode) {
    //     const kenmei = kenmeiCodes.find(x => {
    //       return x.code == formData.kenmeiCode
    //     })
    //
    //     if (kenmei && ) {
    //       currentKenmei = {
    //         kenmeiName: kenmei.name,
    //         customerName: kenmei.customerName
    //       }
    //     }
    //
    //   }
    //
    // }

      const contentStyle = isMobile ?
          { width: '100%', maxWidth: 'none'}
      :
          {}

      const paidHolidayLabel = (
        <div>
          <div style={{textAlign: "right"}}>現在の有休利用日数：<span style={paidHolidayStyle}>{currentPaidHoliday.allUseCount}</span>日</div>
          <div style={{textAlign: "right"}}><span style={{marginRight: 10, ...paidHolidayStyle, fontSize: 16}}>【{currentPaidHoliday.baseMonth}月付与対象者】</span>付与残日数：前年<span style={paidHolidayStyle}>{currentPaidHoliday.prevCountRemain}</span>日・当年<span style={paidHolidayStyle}>{currentPaidHoliday.currentCountRemain}</span>日</div>
        </div>
      )
    return (

      <PageBase title={`労務（${editUserName}）`} sub={paidHolidayLabel}>
 
        <Paper style={gStyles.roumuContainer}>
          <Calendar
            approvalDate={match.params ? match.params.approvalDate : ''}
            auth={auth}
            addEvents={events}
            removeEvents={removeEvents}
            onDayClick={handleCalDayClick}
            onEventClick={handleCalEventClick}
            onChangeWeek={handleChangeWeek}
            onWorkHolidayDrop={handleWorkHolidayDrop}
            workHolidayDates={workHolidayDates}
            holidayDates={this.props.holidayDates}
            editUserId={editUserId}
            kenmeiCodes={kenmeiCodes}
          />

        </Paper>

        {/*<FullscreenDialog*/}
            {/*open={formOpen}*/}
            {/*onRequestClose={() => ({})}*/}
            {/*title={'Demo dialog'}*/}
            {/*actionButton={<FlatButton*/}
                {/*label='Done'*/}
                {/*onClick={() => this.setState({ open: false })}*/}
            {/*/>}*/}
        {/*>*/}

          {/*<RoumuForm*/}
              {/*auth={auth}*/}
              {/*sameGroup={sameGroup}*/}
              {/*myData={myData}*/}
              {/*editUserId={editUserId}*/}
              {/*editUserName={editUserName}*/}

              {/*kenmeiCodes={kenmeiCodes}*/}
              {/*kenmeiCodeDataSource={kenmeiCodeDataSource}*/}
              {/*works={works}*/}
              {/*yosanCosts={yosanCosts}*/}
              {/*workHoliday={workHoliday}*/}

              {/*selectedKenmeiCode={selectedKenmeiCode}*/}
              {/*selectedKind={selectedKind}*/}
              {/*selectedYosanId={selectedYosanId}*/}

              {/*currentKenmei={currentKenmei}*/}
              {/*onKenmeiCodeChange={handeleKenmeiCodeChange}*/}
              {/*onClickOK={handleFormOK}*/}
              {/*onClickNext={handleFormNext}*/}
              {/*onClickDelete={this.props.handleFormDelete}*/}
              {/*onClickClose={handleFormClose}*/}
              {/*onClickApproval={this.props.handleFormApproval}*/}
              {/*onClickReply={this.props.handleFormReply}*/}
              {/*onYosanCostClick={handeleYosanCostClick}*/}
              {/*onWorkHolidayClick={handeleWorkHolidayClick}*/}
              {/*initialValues={formData}*/}
              {/*dirty={dirty}*/}
              {/*onLocalStorageSave={handleLocalStorageSave(currentKenmei)}*/}
          {/*/>*/}

        {/*</FullscreenDialog>*/}


        <Dialog
          title={`労務情報`}
          modal={true}
          open={formOpen}
          onRequestClose={() => { }}
          autoScrollBodyContent={true}
          contentStyle={contentStyle}
        >

          <RoumuForm
            auth={auth}
            sameGroup={sameGroup}
            myData={myData}
            editUserId={editUserId}
            editUserName={editUserName}

            kenmeiCodes={kenmeiCodes}
            kenmeiCodeDataSource={kenmeiCodeDataSource}
            works={works}
            yosanCosts={yosanCosts}
            workHoliday={workHoliday}

            selectedKenmeiCode={selectedKenmeiCode}
            selectedKind={selectedKind}
            selectedYosanId={selectedYosanId}

            currentKenmei={currentKenmei}
            onKenmeiCodeChange={handeleKenmeiCodeChange}
            onClickOK={handleFormOK}
            onClickNext={handleFormNext}
            onClickDelete={this.props.handleFormDelete}
            onClickClose={handleFormClose}
            onClickApproval={this.props.handleFormApproval}
            onClickReply={this.props.handleFormReply}
            onYosanCostClick={handeleYosanCostClick}
            onWorkHolidayClick={handeleWorkHolidayClick}
            initialValues={formData}
            dirty={dirty}
            onLocalStorageSave={handleLocalStorageSave(currentKenmei)}
            onFormReset={handleFormReset}
          />

        </Dialog>

        {
          auth.user.permission == 2 &&
          <Dialog
            title="労務承認"
            modal={true}
            open={approval.open}
            actions={[
              <FlatButton
                label="キャンセル"
                primary={true}
                labelStyle={{ color: colors.grey500, lineHeight: '40px' }}
                style={{ height: '40px', width: '120px', marginRight: '20px' }}
                onTouchTap={handleApprovalClose}
              />
              ,
              <FlatButton
                label="承認"
                labelPosition="before"
                primary={true}
                labelStyle={{color: colors.white, lineHeight: '40px'}}
                style={{height: '40px', width: '100px'}}
                backgroundColor={colors.grey600}
                hoverColor={colors.grey800}
                icon={<PersonIcon color={colors.red400}/>}
                onTouchTap={handleApprovalOK(editUserId, approval.date)}
              />
            ]}
          >
            {approval.date} 一括承認を行います。
          </Dialog>
        }

      </PageBase>
    )
  }
}

const selector = formValueSelector('roumuForm')
const mapStateToProps = (state) => ({
  auth: state.auth,
  editUserId: state.roumu.editUserId,
  editUserName: state.roumu.editUserName,
  editUser: state.roumu.editUser,

  kenmeiCodes: state.roumu.kenmeiCodes,
  kenmeiCodeDataSource: state.roumu.kenmeiCodeDataSource,
  works: state.roumu.works,
  yosanCosts: state.roumu.yosanCosts,
  workHoliday: state.roumu.workHoliday,


  events: state.roumu.events,
  removeEvents: state.roumu.removeEvents,

  currentKenmei: state.roumu.currentKenmei,

  formOpen: state.roumu.formOpen,
  formData: state.roumu.formData,

  approval: state.roumu.approval,
  alertOpen: state.roumu.alertOpen,

  currentPaidHoliday: state.roumu.currentPaidHoliday,

  //holiday
  subHolidayId: state.roumu.subHolidayId,
  subHolidayDate: state.roumu.subHolidayDate, 
  workHolidayId: state.roumu.workHolidayId,
  workHolidayDate: state.roumu.workHolidayDate, 
  workHolidayMode: state.roumu.workHolidayMode, 
  subHolidayFormOpen: state.roumu.subHolidayFormOpen,
  subHolidayFormEdit: state.roumu.subHolidayFormEdit,
  workHolidayDates: state.roumu.workHolidayDates,
  holidayDates: state.roumu.holidayDates,
  selectedKenmeiCode: selector(state, 'kenmeiCode'),
  selectedKind: selector(state, 'kind'),
  selectedYosanId: selector(state, 'yosanId'),
  dirty: isDirty('roumuForm')(state),
})

const mapStateToDispatch = (dispatch) => ({
  init: (userId, start, end) => {
    dispatch(actions.systemRoumuInit(userId, start, end))
  },

  handleChangeWeek: (userId, start, end) => {
    dispatch(actions.systemRoumuGetEvents(userId, start, end))
  },

  handeleKenmeiCodeChange: (change) => {
    dispatch(actions.reducerRoumuSetCurrentKenmei(change))
  },

  handeleYosanCostClick: (id, kenmeiCode, costId) => () => {
    dispatch(actions.systemRoumuGetYosanCosts(id, kenmeiCode, costId))
  },

  handeleWorkHolidayClick: (userId) => () => {
    dispatch(actions.systemRoumuGetWorkHoliday(userId))
  },

  handleCalDayClick: (kenmeiCodes) => (date, allDay, jsEvent, view) => {
    // console.log(date)
    // alert(1)
    // if (!date.hasTime()) {
    //   return
    // }
    const event = {
      date: date.format('YYYY/MM/DD')
    }
    dispatch(actions.userRoumuFormOpen(event, kenmeiCodes))
  },
  handleCalEventClick: (event) => {

    switch(event.eventType) {
      case 'basic':
      case 'holidayAllDay':
        dispatch(actions.userRoumuFormOpen(event))
        break;
      case 'holidayAllDayWork':
        dispatch(actions.reducerRoumuAlertDialogOpen())
        break;
      case 'approval':
        if (event.approval != 2) {
          dispatch(actions.reducerRoumuApprovalDialogOpen(event.date))
        }
        break;
      case 'subHoliday':
        dispatch(actions.reducerRoumuSubHolidayFormOpen(
          event.subHolidayId,
          event.subHolidayDate,
          event.workHolidayId, 
          event.workHolidayDate, 
          null))
        break;
      default:
    }

    // if (event.allDay) {
    //   dispatch(actions.reducerRoumuApprovalDialogOpen(event.date))
    // } else {
    //   dispatch(actions.userRoumuFormOpen(event))
    // }

  },

  handleAlertClose: () => {
    dispatch(actions.reducerRoumuAlertDialogClose())
  },

  handleApprovalClose: () => {
    dispatch(actions.reducerRoumuApprovalDialogClose())
  },
  handleApprovalOK: (userId, date) => () => {
    dispatch(actions.userRoumuApproval(userId, null, date))
  },
  handleApprovalReplyOK: (userId, date) => () => {
    dispatch(actions.userRoumuApproval(userId, null, date, true))
  },

  handleFormReset : () => {
    dispatch(actions.reducerRoumuFormReset())
    dispatch(reset('roumuForm'))
  },

  handleFormOK: (userId, yosanCosts, workHoliday) => {
    return (values) => {

      const errors = validate(values)
      if (Object.keys(errors).length) {
        dispatch(stopSubmit(`roumuForm`, errors))
        return
      }

      if (values.kind && (values.kind == 4 || values.kind == 10)) {

        if (workHoliday && values.workHolidayDate) {

          const match = workHoliday.find(x => {
            return x.date == values.workHolidayDate && x.diff == 240
          });

          if (match) {
            const errors = { kind: '振替対象が不正です。', workHolidayDate: '振替対象が不正です。' }
            dispatch(stopSubmit(`roumuForm`, errors))
            return
          }

        }

      }

      const newObj = Object.assign({}, values, {userId: userId})
      dispatch(actions.userRoumuRegistEvent(newObj, false, yosanCosts))
    }
  },

  handleFormNext: (userId, yosanCosts, workHoliday) => {
    return (values) => {

      const errors = validate(values)
      if (Object.keys(errors).length) {
        dispatch(stopSubmit(`roumuForm`, errors))
        return
      }

      if (values.kind && (values.kind == 4 && values.kind == 10) && values.workHolidayDate && workHoliday) {
        workHoliday.forEach(x => {
          if (x.date == values.workHolidayDate && x.diff == 240) {
            const errors = {kind: '振替対象が不正です。', workHolidayDate: '振替対象が不正です。'}
            dispatch(stopSubmit(`roumuForm`, errors))
            return
          }
        });
      }

      const newObj = Object.assign({}, values, {userId: userId}, yosanCosts)
      dispatch(actions.userRoumuRegistEvent(newObj, true))
    }
  },
  handleFormDelete: (userId, yosanCosts) => {
    return (values) => {
      if (window.confirm("労務を削除してもよろしいですか？")) {
        const newObj = Object.assign({}, values, {userId: userId, delete: true})
        dispatch(actions.userRoumuRegistEvent(newObj, false, yosanCosts))
      }
    }
  },
  handleFormReply: (userId) => {
    return (values) => {
      dispatch(actions.userRoumuApproval(userId, values.id, values.date, true))
    }
  },
  handleFormApproval: (userId) => {
    return (values) => {
      dispatch(actions.userRoumuApproval(userId, values.id, values.date))
    }
  },
  handleFormClose: (dirty) => () => {

    if (dirty) {
      if (window.confirm('入力した情報は保存されません。よろしいですか？')) {
        dispatch(actions.userRoumuFormClose())
      }
    } else {
        dispatch(actions.userRoumuFormClose())
    }

  },


  //work holiday
  handleWorkHolidayDrop: (workHolidayId, subHolidayDate, workHolidayDate, mode, edit) => {
      dispatch(actions.reducerRoumuSubHolidayFormOpen(
      null, subHolidayDate, workHolidayId, workHolidayDate, mode))
  },
  handleSubHolidayFormClose: () => {
    dispatch(actions.reducerRoumuSubHolidayFormClose())
  },
  handleSubHolidayFormAllDay: (userId, workHolidayId) => {
    return (values) => {
      const newObj = Object.assign({}, values, {userId: userId, workHolidayId: workHolidayId, range: 'all'})
      dispatch(actions.userRoumuRegistSubHoliday(newObj))
    }
  },
  handleSubHolidayFormHalfDay: (userId, workHolidayId) => {
    return (values) => {
      const newObj = Object.assign({}, values, {userId: userId, workHolidayId: workHolidayId, range: 'half'})
      dispatch(actions.userRoumuRegistSubHoliday(newObj))
    }
  },
  handleSubHolidayFormDelete: (userId, workHolidayId, subHolidayId) => {
    return (values) => {
      const newObj = Object.assign({}, values, {userId: userId, workHolidayId: workHolidayId, subHolidayId})
      dispatch(actions.userRoumuRegistSubHoliday(newObj))
    }
  },

  handleLocalStorageSave : (currentKenmei) => (values) => {
    if (!window.localStorage) {
      window.alert('お使いのブラウザでは固定できません。他のブラウザを使用して下さい。')
      return
    }
    window.localStorage.setItem('roumu', JSON.stringify(values))
    window.localStorage.setItem('currentKenmei', JSON.stringify(currentKenmei))
    dispatch(actions.reducerSnackBar(true, '入力値を固定しました。', colors.green400))
  },

})

Roumu = connect(
  mapStateToProps,
  mapStateToDispatch
)(Roumu)

export default Roumu


// WEBPACK FOOTER //
// ./src/containers/Roumu.js